<ion-header class="ion-no-border">

  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="close()">
        <fa-icon [icon]="['far', 'times']" size="lg" [fixedWidth]="true" slot="start"></fa-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>Store credit payment</ion-title>
  </ion-toolbar>

</ion-header>

<ion-content>

  @if (cart) {
    <ion-grid class="large-inputs" style="width: 400px;">
      <ion-row class="ion-align-items-center ion-justify-content-center">
        <ion-col>
          <ion-list>
            @if (store_credit != undefined) {
              <ion-item lines="full">
                <ion-label>Store credit balance</ion-label>
                {{cart.currency.sign}}{{store_credit.balance | number:'1.2'}}
              </ion-item>
            }
            <ion-item lines="full">
              <ion-label>Amount due</ion-label>
              {{cart.currency.sign}}{{cart.amount_due | number:'1.2'}}
            </ion-item>
            <ion-item lines="full">
              <ion-input #payment_amount_input type="tel" class="ion-text-right" inputmode="decimal" maxlength="10" label="Payment amount" [(ngModel)]="payment_amount" (ngModelChange)="sanitisePaymentAmount()"></ion-input>
            </ion-item>
            @if (store_credit != undefined && payment.price > 0) {
              <ion-item button="true" lines="none" detail="false" color="success" class="ion-text-center" (click)="addPayment()">
                <ion-label>ADD PAYMENT</ion-label>
              </ion-item>
            }
          </ion-list>
        </ion-col>
      </ion-row>
    </ion-grid>
  }

</ion-content>